import * as S from '../../styles/BoardSettingStyle';
import { CFormInput, CFormLabel, CFormSelect } from '@coreui/react';
import { AdminBoardSettingTypes } from '@typedef/components/Admin/BoardSetting/admin.board.setting.types';

type Props = {
  boardInfo: AdminBoardSettingTypes;
  onChangeBoardInfo: (id: string, name: string, value: string) => void;
};

const InjectionHeader = ({ boardInfo, onChangeBoardInfo }: Props) => {
  return (
    <div className='header-body between'>
      <S.Inputs width='49%'>
        <CFormLabel>항암주사실 위치</CFormLabel>
        <CFormSelect
          value={boardInfo.broomNumber ? boardInfo?.broomNumber[0] ?? '' : ''}
          onChange={(e) => {
            onChangeBoardInfo('broomNumber0', 'broomNumber', e.target.value);
          }}>
          <option value=''>위치 선택</option>
          <option value='1'>1층</option>
          <option value='2'>2층</option>
        </CFormSelect>
      </S.Inputs>
      <S.Inputs width='49%'>
        <CFormInput
          type='text'
          label='항암주사실'
          value={
            boardInfo.bname === '-' || boardInfo.bname === null
              ? ''
              : boardInfo.bname
          }
          onChange={(e) => {
            onChangeBoardInfo('bname', 'bname', e.target.value);
          }}
          placeholder='항암주사실 이름 입력'
        />
      </S.Inputs>
    </div>
  );
};

export default InjectionHeader;
